import * as i0 from '@angular/core';
import { TemplateRef, Directive, Inject, Input, InjectionToken, ElementRef, SkipSelf, forwardRef, EventEmitter, ChangeDetectorRef, HostBinding, Output, Component, ChangeDetectionStrategy, Optional, ContentChildren, Pipe, ContentChild, NgModule } from '@angular/core';
import { map, switchMap, distinctUntilChanged, takeUntil, filter, startWith } from 'rxjs/operators';
import { IntersectionObserverService, INTERSECTION_ROOT_MARGIN, INTERSECTION_THRESHOLD } from '@ng-web-apis/intersection-observer';
import * as i4 from '@taiga-ui/cdk';
import { tuiCreateToken, tuiProvideOptions, AbstractTuiController, tuiTypedFromEvent, tuiPreventDefault, tuiDefaultSort, TuiTableSortKeyException, EMPTY_QUERY, tuiPure, TuiDestroyService, tuiQueryListChanges, TuiMapperPipeModule } from '@taiga-ui/cdk';
import * as i1$1 from '@taiga-ui/core';
import { TUI_TEXTFIELD_APPEARANCE_DIRECTIVE, TuiTextfieldAppearanceDirective, TuiAppearance, TUI_TEXTFIELD_LABEL_OUTSIDE, TUI_TEXTFIELD_SIZE, MODE_PROVIDER, TUI_MODE, TUI_ELEMENT_REF, tuiWatchedControllerFactory, TuiSvgModule } from '@taiga-ui/core';
import { TUI_INPUT_COUNT_OPTIONS, TUI_ARROW_OPTIONS } from '@taiga-ui/kit';
import * as i1 from 'rxjs';
import { ReplaySubject } from 'rxjs';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { __decorate, __awaiter } from 'tslib';
import * as i3 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { NgControl } from '@angular/forms';
const _c0 = ["tuiTh", ""];
function TuiThComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function TuiThComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.updateSorterAndDirection());
    });
    i0.ɵɵelementContainer(1, 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "tui-svg", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(2);
    i0.ɵɵclassProp("t-sort_sorted", ctx_r0.isCurrent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.table.change$), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.icon);
  }
}
function TuiThComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function TuiThComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("tuiResized", function TuiThComponent_div_3_Template_div_tuiResized_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.onResized($event));
    });
    i0.ɵɵelementEnd();
  }
}
const _c1 = ["*"];
const _c2 = ["tuiTd", ""];
const _c3 = ["tuiTr", ""];
function TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_td_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.ngIf;
    const key_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r7[key_r3], " ");
  }
}
function TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_td_0_Template, 2, 1, "td", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r4.item$));
  }
}
function TuiTrComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, TuiTrComponent_ng_container_0_ng_container_1_ng_template_1_Template, 2, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const key_r3 = ctx.$implicit;
    const _r5 = i0.ɵɵreference(2);
    const items_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngTemplateOutlet", (items_r1[key_r3] == null ? null : items_r1[key_r3].template) || _r5);
  }
}
function TuiTrComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiTrComponent_ng_container_0_ng_container_1_Template, 3, 1, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.table.columns);
  }
}
const _c4 = ["tuiTbody", ""];
function TuiTbodyComponent_tr_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r4 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r4, " ");
  }
}
function TuiTbodyComponent_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "th", 1)(2, "button", 2);
    i0.ɵɵlistener("click", function TuiTbodyComponent_tr_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onClick());
    });
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtemplate(4, TuiTbodyComponent_tr_0_ng_container_4_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "tui-svg", 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("colSpan", ctx_r0.table.columns.length);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r0.heading);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("t-chevron_rotated", ctx_r0.open);
    i0.ɵɵproperty("src", ctx_r0.arrowOptions.iconLarge);
  }
}
function TuiTbodyComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
function TuiTbodyComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
    i0.ɵɵpipe(1, "tuiMapper");
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const index_r9 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r7.row.template)("ngTemplateOutletContext", i0.ɵɵpipeBind3(1, 2, item_r8, ctx_r7.toContext, index_r9));
  }
}
function TuiTbodyComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiTbodyComponent_ng_container_2_ng_container_1_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.sorted);
  }
}
const _c5 = ["tuiThGroup", ""];
function TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_th_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const key_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", key_r3.toString(), " ");
  }
}
function TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_th_0_Template, 2, 1, "th", 4);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r4.th && !ctx_r4.heads.length);
  }
}
function TuiThGroupComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_ng_container_1_ng_template_1_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const key_r3 = ctx.$implicit;
    const _r5 = i0.ɵɵreference(2);
    const headings_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngTemplateOutlet", (headings_r1[key_r3.toString()] == null ? null : headings_r1[key_r3.toString()].template) || _r5);
  }
}
function TuiThGroupComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.table.columns);
  }
}
let TuiCellDirective = /*#__PURE__*/(() => {
  class TuiCellDirective {
    constructor(template) {
      this.template = template;
      this.tuiCell = '';
    }
  }
  TuiCellDirective.ɵfac = function TuiCellDirective_Factory(t) {
    return new (t || TuiCellDirective)(i0.ɵɵdirectiveInject(TemplateRef));
  };
  TuiCellDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiCellDirective,
    selectors: [["", "tuiCell", ""]],
    inputs: {
      tuiCell: "tuiCell"
    }
  });
  return TuiCellDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Stream of sticky stuck events
 */
const TUI_STUCK = new InjectionToken(`[TUI_STUCK]`);
const TUI_STUCK_PROVIDER = {
  provide: TUI_STUCK,
  deps: [ElementRef, IntersectionObserverService],
  useFactory: ({
    nativeElement
  }, entries$) => {
    const stream$ = entries$.pipe(map(([{
      intersectionRatio
    }]) => intersectionRatio < 1));
    nativeElement[`$.class._stuck`] = stream$;
    return stream$;
  }
};
const TUI_TABLE_PROVIDERS = [{
  provide: INTERSECTION_ROOT_MARGIN,
  useValue: `10000px 10000px 10000px 0px`
}, {
  provide: INTERSECTION_THRESHOLD,
  useValue: [0, 1]
}, {
  provide: TUI_TEXTFIELD_APPEARANCE_DIRECTIVE,
  useFactory: () => {
    const directive = new TuiTextfieldAppearanceDirective();
    directive.appearance = TuiAppearance.Table;
    return directive;
  }
}, {
  provide: TUI_TEXTFIELD_LABEL_OUTSIDE,
  useValue: {
    labelOutside: true
  }
}, {
  provide: TUI_INPUT_COUNT_OPTIONS,
  deps: [[new SkipSelf(), TUI_INPUT_COUNT_OPTIONS]],
  useFactory: options => Object.assign(Object.assign({}, options), {
    hideButtons: true
  })
}, {
  provide: TUI_TEXTFIELD_SIZE,
  useExisting: forwardRef(() => TuiTableDirective)
}, IntersectionObserverService, MODE_PROVIDER, TUI_STUCK_PROVIDER];
const TUI_TABLE_DEFAULT_OPTIONS = {
  sticky: false,
  resizable: false,
  open: true,
  size: `m`,
  direction: 1,
  sortIcons: {
    asc: `tuiIconSortAscending`,
    desc: `tuiIconSortDescending`,
    off: `tuiIconSortOff`
  }
};
const TUI_TABLE_OPTIONS = tuiCreateToken(TUI_TABLE_DEFAULT_OPTIONS);
function tuiTableOptionsProvider(options) {
  return tuiProvideOptions(TUI_TABLE_OPTIONS, options, TUI_TABLE_DEFAULT_OPTIONS);
}
let TuiTableDirective = /*#__PURE__*/(() => {
  class TuiTableDirective extends AbstractTuiController {
    constructor(entries$, mode$, stuck$, options, cdr) {
      super();
      this.entries$ = entries$;
      this.mode$ = mode$;
      this.stuck$ = stuck$;
      this.options = options;
      this.cdr = cdr;
      this.columns = [];
      this.size = this.options.size;
      this.direction = this.options.direction;
      this.directionChange = new EventEmitter();
      this.sorterChange = new EventEmitter();
      this.sorter = () => 0;
    }
    updateSorterAndDirection(sorter) {
      if (this.sorter === sorter) {
        this.updateDirection(this.direction === 1 ? -1 : 1);
      } else {
        this.updateSorter(sorter);
        this.updateDirection(1);
      }
    }
    ngAfterViewInit() {
      this.cdr.detectChanges();
    }
    updateSorter(sorter) {
      this.sorter = sorter || (() => 0);
      this.sorterChange.emit(this.sorter);
      this.change$.next();
    }
    updateDirection(direction) {
      this.direction = direction;
      this.directionChange.emit(this.direction);
      this.change$.next();
    }
  }
  TuiTableDirective.ɵfac = function TuiTableDirective_Factory(t) {
    return new (t || TuiTableDirective)(i0.ɵɵdirectiveInject(IntersectionObserverService), i0.ɵɵdirectiveInject(TUI_MODE), i0.ɵɵdirectiveInject(TUI_STUCK), i0.ɵɵdirectiveInject(TUI_TABLE_OPTIONS), i0.ɵɵdirectiveInject(ChangeDetectorRef));
  };
  TuiTableDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiTableDirective,
    selectors: [["table", "tuiTable", ""]],
    hostAttrs: [2, "border-collapse", "separate"],
    hostVars: 1,
    hostBindings: function TuiTableDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiTableDirective___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        })("$.class._stuck", function TuiTableDirective___class__stuck_HostBindingHandler() {
          return ctx.stuck$;
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
      }
    },
    inputs: {
      columns: "columns",
      size: "size",
      direction: "direction",
      sorter: "sorter"
    },
    outputs: {
      directionChange: "directionChange",
      sorterChange: "sorterChange"
    },
    features: [i0.ɵɵProvidersFeature(TUI_TABLE_PROVIDERS), i0.ɵɵInheritDefinitionFeature]
  });
  return TuiTableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiDirectionOrderDirective = /*#__PURE__*/(() => {
  class TuiDirectionOrderDirective {
    constructor(table) {
      this.table = table;
      this.directionOrderChange = this.table.directionChange.pipe(map(dir => dir === 1 ? 'asc' : 'desc'));
    }
    set directionOrder(order) {
      this.table.direction = order === 'asc' ? 1 : -1;
    }
  }
  TuiDirectionOrderDirective.ɵfac = function TuiDirectionOrderDirective_Factory(t) {
    return new (t || TuiDirectionOrderDirective)(i0.ɵɵdirectiveInject(TuiTableDirective));
  };
  TuiDirectionOrderDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiDirectionOrderDirective,
    selectors: [["table", "tuiTable", "", "tuiDirectionOrder", ""]],
    inputs: {
      directionOrder: "directionOrder"
    },
    outputs: {
      directionOrderChange: "directionOrderChange"
    }
  });
  return TuiDirectionOrderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiHeadDirective = /*#__PURE__*/(() => {
  class TuiHeadDirective {
    constructor(template) {
      this.template = template;
    }
  }
  TuiHeadDirective.ɵfac = function TuiHeadDirective_Factory(t) {
    return new (t || TuiHeadDirective)(i0.ɵɵdirectiveInject(TemplateRef));
  };
  TuiHeadDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiHeadDirective,
    selectors: [["", "tuiHead", ""]],
    inputs: {
      tuiHead: "tuiHead"
    }
  });
  return TuiHeadDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiResizedDirective = /*#__PURE__*/(() => {
  class TuiResizedDirective {
    constructor(doc, el, parentRef) {
      this.doc = doc;
      this.el = el;
      this.parentRef = parentRef;
      this.tuiResized = tuiTypedFromEvent(this.el.nativeElement, 'mousedown').pipe(tuiPreventDefault(), switchMap(() => {
        const {
          width,
          right
        } = this.parentRef.nativeElement.getBoundingClientRect();
        return tuiTypedFromEvent(this.doc, 'mousemove').pipe(distinctUntilChanged(), map(({
          clientX
        }) => width + clientX - right), takeUntil(tuiTypedFromEvent(this.doc, 'mouseup')));
      }));
    }
  }
  TuiResizedDirective.ɵfac = function TuiResizedDirective_Factory(t) {
    return new (t || TuiResizedDirective)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_ELEMENT_REF));
  };
  TuiResizedDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiResizedDirective,
    selectors: [["", "tuiResized", ""]],
    outputs: {
      tuiResized: "tuiResized"
    }
  });
  return TuiResizedDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated use `*ngFor` + `tuiTableSort`-pipe instead.
 * See example {@link https://taiga-ui.dev/components/table/Setup}
 * ___
 * TODO v4.0 delete it.
 */
let TuiRowDirective = /*#__PURE__*/(() => {
  class TuiRowDirective {
    constructor(template) {
      this.template = template;
      this.tuiRowOf = [];
    }
    static ngTemplateContextGuard(_dir, _ctx) {
      return true;
    }
  }
  TuiRowDirective.ɵfac = function TuiRowDirective_Factory(t) {
    return new (t || TuiRowDirective)(i0.ɵɵdirectiveInject(TemplateRef));
  };
  TuiRowDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiRowDirective,
    selectors: [["ng-template", "tuiRow", ""]],
    inputs: {
      tuiRowOf: "tuiRowOf"
    }
  });
  return TuiRowDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiThComponent = /*#__PURE__*/(() => {
  class TuiThComponent {
    constructor(options, head, table) {
      this.options = options;
      this.head = head;
      this.table = table;
      this.sorter = this.head ? (a, b) => tuiDefaultSort(a[this.key], b[this.key]) : null;
      this.resizable = this.options.resizable;
      this.sticky = this.options.sticky;
      this.width = null;
    }
    get key() {
      if (!this.head) {
        throw new TuiTableSortKeyException();
      }
      return this.head.tuiHead;
    }
    get isCurrent() {
      return !!this.sorter && !!this.table && this.sorter === this.table.sorter;
    }
    get icon() {
      var _a;
      if (this.isCurrent) {
        return ((_a = this.table) === null || _a === void 0 ? void 0 : _a.direction) === 1 ? this.options.sortIcons.desc : this.options.sortIcons.asc;
      }
      return this.options.sortIcons.off;
    }
    updateSorterAndDirection() {
      var _a;
      (_a = this.table) === null || _a === void 0 ? void 0 : _a.updateSorterAndDirection(this.isCurrentAndAscDirection ? null : this.sorter);
    }
    onResized(width) {
      this.width = width;
    }
    get isCurrentAndAscDirection() {
      var _a, _b;
      return this.sorter === ((_a = this.table) === null || _a === void 0 ? void 0 : _a.sorter) && ((_b = this.table) === null || _b === void 0 ? void 0 : _b.direction) === -1;
    }
  }
  TuiThComponent.ɵfac = function TuiThComponent_Factory(t) {
    return new (t || TuiThComponent)(i0.ɵɵdirectiveInject(TUI_TABLE_OPTIONS), i0.ɵɵdirectiveInject(TuiHeadDirective, 8), i0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective), 8));
  };
  TuiThComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiThComponent,
    selectors: [["th", "tuiTh", ""]],
    hostVars: 4,
    hostBindings: function TuiThComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.width, "px");
        i0.ɵɵclassProp("_sticky", ctx.sticky);
      }
    },
    inputs: {
      sorter: "sorter",
      resizable: "resizable",
      sticky: "sticky"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: TUI_ELEMENT_REF,
      useExisting: ElementRef
    }])],
    attrs: _c0,
    ngContentSelectors: _c1,
    decls: 4,
    vars: 3,
    consts: [["type", "button", "class", "t-sort", 3, "t-sort_sorted", "click", 4, "ngIf", "ngIfElse"], ["content", ""], ["class", "t-bar", 3, "tuiResized", 4, "ngIf"], ["type", "button", 1, "t-sort", 3, "click"], [3, "ngTemplateOutlet"], [1, "t-sort-icon", 3, "src"], [1, "t-bar", 3, "tuiResized"]],
    template: function TuiThComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, TuiThComponent_button_0_Template, 5, 7, "button", 0)(1, TuiThComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(3, TuiThComponent_div_3_Template, 1, 0, "div", 2);
      }
      if (rf & 2) {
        const _r2 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.sorter && ctx.table)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.resizable);
      }
    },
    dependencies: [i1$1.TuiSvgComponent, i2.NgIf, i2.NgTemplateOutlet, TuiResizedDirective, i2.AsyncPipe],
    styles: ["[_nghost-%COMP%]{transition-property:box-shadow;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:relative;top:0;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;font-weight:bold;color:var(--tui-text-02);background:var(--tui-base-01);cursor:default;padding:0 .75rem;box-sizing:border-box;box-shadow:0 .3125rem #ededed00;border:1px solid var(--tui-base-04);transform:translate(0)}[_nghost-%COMP%]:not(:first-child){border-left:none}._sticky[_nghost-%COMP%], ._stuck   ._sticky[_nghost-%COMP%]{position:-webkit-sticky;position:sticky;z-index:30}._sticky[_nghost-%COMP%]:first-child, ._stuck   ._sticky[_nghost-%COMP%]:first-child{left:0}._sticky[_nghost-%COMP%]:after, ._stuck   ._sticky[_nghost-%COMP%]:after{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;content:\"\";position:absolute;top:0;left:100%;bottom:0;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}._stuck   [_nghost-%COMP%]{z-index:20}tr:not(:first-child)[_nghost-%COMP%], tr:not(:first-child)   [_nghost-%COMP%]{border-top:none}table[data-size=\"l\"][_nghost-%COMP%], table[data-size=\"l\"]   [_nghost-%COMP%]{height:var(--tui-height-l);font:var(--tui-font-text-m);font-weight:bold;padding:0 1rem}thead[tuiThead][_nghost-%COMP%], thead[tuiThead]   [_nghost-%COMP%]{position:-webkit-sticky;position:sticky}table._stuck._sticky[_nghost-%COMP%]:after, table._stuck   ._sticky[_nghost-%COMP%]:after{opacity:1}thead[tuiThead]._stuck[_nghost-%COMP%], thead[tuiThead]._stuck   [_nghost-%COMP%]{box-shadow:0 .3125rem #edededb3}table[data-mode=\"onDark\"][_nghost-%COMP%]:after, table[data-mode=\"onDark\"]   [_nghost-%COMP%]:after{background:rgba(60,60,60,.9)}table[data-mode=\"onDark\"]   thead[tuiThead]._stuck[_nghost-%COMP%], table[data-mode=\"onDark\"]   thead[tuiThead]._stuck   [_nghost-%COMP%]{box-shadow:0 .3125rem #3c3c3ce6}table[data-mode=\"onDark\"]   thead[tuiThead]._stuck[_nghost-%COMP%]:first-child, table[data-mode=\"onDark\"]   thead[tuiThead]._stuck   [_nghost-%COMP%]:first-child{box-shadow:.0625rem .3125rem #3c3c3ce6}table[data-size=\"l\"]   thead[tuiThead]   tr:nth-child(2)[_nghost-%COMP%], table[data-size=\"l\"]   thead[tuiThead]   tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-l)}table[data-size=\"m\"]   thead[tuiThead]   tr:nth-child(2)[_nghost-%COMP%], table[data-size=\"m\"]   thead[tuiThead]   tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-m)}table[data-size=\"s\"]   thead[tuiThead]   tr:nth-child(2)[_nghost-%COMP%], table[data-size=\"s\"]   thead[tuiThead]   tr:nth-child(2)   [_nghost-%COMP%]{top:var(--tui-height-s)}.t-sort[_ngcontent-%COMP%]{transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;display:inline-flex;flex-direction:inherit;align-items:center;outline:none;font-weight:bold;cursor:pointer}.t-sort_sorted[_ngcontent-%COMP%]{color:var(--tui-text-01)}.t-sort[_ngcontent-%COMP%]:focus-visible{background:var(--tui-selection)}.t-sort[_ngcontent-%COMP%]:hover{color:var(--tui-text-01)}.t-bar[_ngcontent-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:absolute;top:0;bottom:0;right:-1px;width:3px;justify-self:flex-end;border-left:2px solid transparent;background:var(--tui-support-12);background-clip:content-box;cursor:ew-resize;opacity:0}.t-bar[_ngcontent-%COMP%]:hover, .t-bar[_ngcontent-%COMP%]:active{opacity:1}"],
    changeDetection: 0
  });
  return TuiThComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiSortableDirective = /*#__PURE__*/(() => {
  class TuiSortableDirective {
    constructor(sortBy, table, th) {
      this.sortBy = sortBy;
      this.table = table;
      this.th = th;
      this.sorter = () => 0;
    }
    get key() {
      return this.th.key;
    }
    ngOnInit() {
      this.sorter = this.match ? this.table.sorter : this.sorter;
      this.th.sorter = this.sorter;
    }
    ngDoCheck() {
      if (this.match && this.table.sorter !== this.sorter) {
        this.table.updateSorter(this.sorter);
      }
    }
    get match() {
      return this.sortBy.tuiSortBy === this.key;
    }
  }
  TuiSortableDirective.ɵfac = function TuiSortableDirective_Factory(t) {
    return new (t || TuiSortableDirective)(i0.ɵɵdirectiveInject(forwardRef(() => TuiSortByDirective)), i0.ɵɵdirectiveInject(TuiTableDirective), i0.ɵɵdirectiveInject(TuiThComponent));
  };
  TuiSortableDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiSortableDirective,
    selectors: [["th", "tuiTh", "", "tuiSortable", ""]]
  });
  return TuiSortableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiSortByDirective = /*#__PURE__*/(() => {
  class TuiSortByDirective {
    constructor(table) {
      this.table = table;
      this.sortables = EMPTY_QUERY;
      this.tuiSortBy = null;
      this.tuiSortByChange = this.table.sorterChange.pipe(filter(() => !!this.sortables.length), map(sorter => this.getKey(sorter)));
    }
    getKey(sorter) {
      var _a;
      return ((_a = this.sortables.find(s => s.sorter === sorter)) === null || _a === void 0 ? void 0 : _a.key) || null;
    }
  }
  TuiSortByDirective.ɵfac = function TuiSortByDirective_Factory(t) {
    return new (t || TuiSortByDirective)(i0.ɵɵdirectiveInject(TuiTableDirective));
  };
  TuiSortByDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiSortByDirective,
    selectors: [["table", "tuiTable", "", "tuiSortBy", ""]],
    contentQueries: function TuiSortByDirective_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TuiSortableDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortables = _t);
      }
    },
    inputs: {
      tuiSortBy: "tuiSortBy"
    },
    outputs: {
      tuiSortByChange: "tuiSortByChange"
    }
  });
  return TuiSortByDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTheadDirective = /*#__PURE__*/(() => {
  class TuiTheadDirective {
    constructor(stuck$) {
      this.stuck$ = stuck$;
    }
  }
  TuiTheadDirective.ɵfac = function TuiTheadDirective_Factory(t) {
    return new (t || TuiTheadDirective)(i0.ɵɵdirectiveInject(TUI_STUCK));
  };
  TuiTheadDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiTheadDirective,
    selectors: [["thead", "tuiThead", ""]],
    hostBindings: function TuiTheadDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.class._stuck", function TuiTheadDirective___class__stuck_HostBindingHandler() {
          return ctx.stuck$;
        });
      }
    },
    features: [i0.ɵɵProvidersFeature([TUI_STUCK_PROVIDER, IntersectionObserverService, {
      provide: INTERSECTION_ROOT_MARGIN,
      useValue: '0px 10000px 10000px 10000px'
    }])]
  });
  return TuiTheadDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TuiTableSortPipe {
  constructor(table) {
    this.table = table;
  }
  transform(data) {
    return this.sort(data, this.table.sorter, this.table.direction);
  }
  sort(data, sorter, direction) {
    return [...data].sort((a, b) => direction * sorter(a, b));
  }
}
TuiTableSortPipe.ɵfac = function TuiTableSortPipe_Factory(t) {
  return new (t || TuiTableSortPipe)(i0.ɵɵdirectiveInject(TuiTableDirective, 16));
};
TuiTableSortPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
  name: "tuiTableSort",
  type: TuiTableSortPipe,
  pure: false
});
__decorate([tuiPure], TuiTableSortPipe.prototype, "sort", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_TABLE_PROVIDER = [TuiDestroyService, TuiTableSortPipe, {
  provide: TuiTableDirective,
  deps: [[new SkipSelf(), TuiTableDirective], ChangeDetectorRef, TuiDestroyService],
  useFactory: tuiWatchedControllerFactory
}];
let TuiTdComponent = /*#__PURE__*/(() => {
  class TuiTdComponent {}
  TuiTdComponent.ɵfac = function TuiTdComponent_Factory(t) {
    return new (t || TuiTdComponent)();
  };
  TuiTdComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTdComponent,
    selectors: [["th", "tuiTd", ""], ["td", "tuiTd", ""]],
    contentQueries: function TuiTdComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, NgControl, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.control = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function TuiTdComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("_editable", ctx.control);
      }
    },
    attrs: _c2,
    ngContentSelectors: _c1,
    decls: 1,
    vars: 0,
    template: function TuiTdComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{position:relative;height:var(--tui-height-m);font:var(--tui-font-text-s);text-align:left;padding:0 .75rem;background:var(--tui-base-01);border:1px solid var(--tui-base-04);border-top:none;box-sizing:border-box;transform:translate(0)}[_nghost-%COMP%]:first-child{left:0}[_nghost-%COMP%]:not(:first-child){border-left:none}._editable[_nghost-%COMP%]:focus-within{z-index:1}._editable[_nghost-%COMP%]{padding:0;vertical-align:top}th[_nghost-%COMP%]{position:-webkit-sticky;position:sticky;z-index:1}th[_nghost-%COMP%]:after{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;content:\"\";position:absolute;top:0;bottom:0;left:100%;width:.3125rem;pointer-events:none;background:rgba(237,237,237,.7);opacity:0}th[_nghost-%COMP%]:focus-within:not(:disabled){z-index:11}table[data-mode=\"onDark\"][_nghost-%COMP%]:after, table[data-mode=\"onDark\"]   [_nghost-%COMP%]:after{background:rgba(60,60,60,.9)}table._stuck[_nghost-%COMP%], table._stuck   [_nghost-%COMP%]{z-index:10}table._stuck[_nghost-%COMP%]:last-of-type:after, table._stuck   [_nghost-%COMP%]:last-of-type:after{opacity:1}table[data-size=\"l\"][_nghost-%COMP%], table[data-size=\"l\"]   [_nghost-%COMP%]{font:var(--tui-font-text-m);height:var(--tui-height-l);padding-left:1rem;padding-right:1rem}table[data-size=\"l\"]._editable[_nghost-%COMP%], table[data-size=\"l\"]   ._editable[_nghost-%COMP%]{padding:0}td[_nghost-%COMP%]:focus-within{z-index:1}td[_nghost-%COMP%]:not(:focus-within){z-index:0}"],
    changeDetection: 0
  });
  return TuiTdComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTrComponent = /*#__PURE__*/(() => {
  class TuiTrComponent {
    constructor(table, body) {
      this.table = table;
      this.body = body;
      this.cells = EMPTY_QUERY;
      this.contentReady$ = new ReplaySubject(1);
      this.cells$ = this.contentReady$.pipe(switchMap(() => tuiQueryListChanges(this.cells)), map(cells => cells.reduce((record, item) => Object.assign(Object.assign({}, record), {
        [item.tuiCell]: item
      }), {})));
      this.item$ = this.contentReady$.pipe(switchMap(() => tuiQueryListChanges(this.body.rows)), map(rows =>
      /**
       * TODO v4.0 replace `this.body.sorted` with `this.body.data` (don't forget to drop `sorted`-getter).
       */
      this.body.sorted[rows.findIndex(row => row === this)]));
    }
    ngAfterContentInit() {
      return __awaiter(this, void 0, void 0, function* () {
        yield Promise.resolve();
        this.contentReady$.next(true);
      });
    }
  }
  TuiTrComponent.ɵfac = function TuiTrComponent_Factory(t) {
    return new (t || TuiTrComponent)(i0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective)), i0.ɵɵdirectiveInject(forwardRef(() => TuiTbodyComponent)));
  };
  TuiTrComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTrComponent,
    selectors: [["tr", "tuiTr", ""]],
    contentQueries: function TuiTrComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TuiCellDirective, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cells = _t);
      }
    },
    features: [i0.ɵɵProvidersFeature([TUI_TABLE_PROVIDER])],
    attrs: _c3,
    decls: 2,
    vars: 3,
    consts: [[4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], ["plain", ""], ["tuiTd", "", 4, "ngIf"], ["tuiTd", ""]],
    template: function TuiTrComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TuiTrComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cells$));
      }
    },
    dependencies: [TuiTdComponent, i2.NgIf, i2.NgForOf, i2.NgTemplateOutlet, i2.AsyncPipe],
    encapsulation: 2,
    changeDetection: 0
  });
  return TuiTrComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTbodyComponent = /*#__PURE__*/(() => {
  class TuiTbodyComponent {
    constructor(pipe, options, arrowOptions, table) {
      this.pipe = pipe;
      this.options = options;
      this.arrowOptions = arrowOptions;
      this.table = table;
      this.data = [];
      this.open = this.options.open;
      this.openChange = new EventEmitter();
      this.rows = EMPTY_QUERY;
      this.toContext = ($implicit, index) => ({
        $implicit,
        index
      });
    }
    get sorted() {
      return this.pipe.transform(this.data);
    }
    onClick() {
      this.open = !this.open;
      this.openChange.emit(this.open);
    }
  }
  TuiTbodyComponent.ɵfac = function TuiTbodyComponent_Factory(t) {
    return new (t || TuiTbodyComponent)(i0.ɵɵdirectiveInject(TuiTableSortPipe), i0.ɵɵdirectiveInject(TUI_TABLE_OPTIONS), i0.ɵɵdirectiveInject(TUI_ARROW_OPTIONS), i0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective)));
  };
  TuiTbodyComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTbodyComponent,
    selectors: [["tbody", "tuiTbody", ""]],
    contentQueries: function TuiTbodyComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TuiRowDirective, 5);
        i0.ɵɵcontentQuery(dirIndex, TuiTrComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.row = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rows = _t);
      }
    },
    inputs: {
      data: "data",
      heading: "heading",
      open: "open"
    },
    outputs: {
      openChange: "openChange"
    },
    features: [i0.ɵɵProvidersFeature(TUI_TABLE_PROVIDER)],
    attrs: _c4,
    ngContentSelectors: _c1,
    decls: 3,
    vars: 3,
    consts: [[4, "ngIf"], [1, "t-heading", 3, "colSpan"], ["type", "button", 1, "t-expand", 3, "click"], [1, "t-name"], [4, "polymorpheusOutlet"], [1, "t-chevron", 3, "src"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function TuiTbodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, TuiTbodyComponent_tr_0_Template, 6, 5, "tr", 0)(1, TuiTbodyComponent_ng_container_1_Template, 2, 0, "ng-container", 0)(2, TuiTbodyComponent_ng_container_2_Template, 2, 1, "ng-container", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.heading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.open);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.open && ctx.row);
      }
    },
    dependencies: [i1$1.TuiSvgComponent, i2.NgIf, i3.PolymorpheusOutletDirective, i2.NgForOf, i2.NgTemplateOutlet, i4.TuiMapperPipe],
    styles: ["[_nghost-%COMP%]{border-color:var(--tui-base-04)}[_nghost-%COMP%]   tr[_ngcontent-%COMP%]{border-color:inherit}.t-expand[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;display:flex;width:100%;height:100%;align-items:center;box-sizing:border-box;outline:none;font-weight:bold;cursor:pointer;border-color:inherit}.t-expand[_ngcontent-%COMP%]:focus-visible   .t-name[_ngcontent-%COMP%]{background:var(--tui-selection)}.t-expand[_ngcontent-%COMP%]:before, .t-expand[_ngcontent-%COMP%]:after{content:\"\";position:-webkit-sticky;position:sticky;height:100%;border-left:1px solid;border-color:inherit}.t-expand[_ngcontent-%COMP%]:before{left:0}.t-expand[_ngcontent-%COMP%]:after{right:0}.t-heading[_ngcontent-%COMP%]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;height:var(--tui-height-m);font:var(--tui-font-text-s);padding:0;background:var(--tui-base-02);border-bottom:1px solid var(--tui-base-04);border-color:inherit}.t-heading[_ngcontent-%COMP%]:hover{background:var(--tui-base-03)}table[data-size=\"l\"][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%], table[data-size=\"l\"]   [_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{font:var(--tui-font-text-m);height:var(--tui-height-l)}.t-name[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;left:.75rem;display:inline-block}table[data-size=\"l\"][_nghost-%COMP%]   .t-name[_ngcontent-%COMP%], table[data-size=\"l\"]   [_nghost-%COMP%]   .t-name[_ngcontent-%COMP%]{left:1rem}.t-chevron[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:-webkit-sticky;position:sticky;right:.75rem;margin:0 .6875rem 0 auto}.t-chevron_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}"],
    changeDetection: 0
  });
  return TuiTbodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiThGroupComponent = /*#__PURE__*/(() => {
  class TuiThGroupComponent {
    constructor(table) {
      this.table = table;
      this.heads = EMPTY_QUERY;
      this.heads$ = null;
    }
    ngAfterContentInit() {
      this.heads$ = this.heads.changes.pipe(startWith(null), map(() => this.heads.reduce((record, item) => Object.assign(Object.assign({}, record), {
        [item.tuiHead]: item
      }), {})));
    }
  }
  TuiThGroupComponent.ɵfac = function TuiThGroupComponent_Factory(t) {
    return new (t || TuiThGroupComponent)(i0.ɵɵdirectiveInject(forwardRef(() => TuiTableDirective)));
  };
  TuiThGroupComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiThGroupComponent,
    selectors: [["tr", "tuiThGroup", ""]],
    contentQueries: function TuiThGroupComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TuiThComponent, 5);
        i0.ɵɵcontentQuery(dirIndex, TuiHeadDirective, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.th = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.heads = _t);
      }
    },
    features: [i0.ɵɵProvidersFeature([TUI_TABLE_PROVIDER])],
    attrs: _c5,
    ngContentSelectors: _c1,
    decls: 3,
    vars: 3,
    consts: [[4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], ["plain", ""], ["tuiTh", "", 4, "ngIf"], ["tuiTh", ""]],
    template: function TuiThGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
        i0.ɵɵtemplate(1, TuiThGroupComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        i0.ɵɵpipe(2, "async");
      }
      if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.heads$));
      }
    },
    dependencies: [TuiThComponent, i2.NgIf, i2.NgForOf, i2.NgTemplateOutlet, i2.AsyncPipe],
    encapsulation: 2,
    changeDetection: 0
  });
  return TuiThGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTableModule = /*#__PURE__*/(() => {
  class TuiTableModule {}
  TuiTableModule.ɵfac = function TuiTableModule_Factory(t) {
    return new (t || TuiTableModule)();
  };
  TuiTableModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiTableModule
  });
  TuiTableModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, PolymorpheusModule, TuiMapperPipeModule, TuiSvgModule]]
  });
  return TuiTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_STUCK, TUI_STUCK_PROVIDER, TUI_TABLE_DEFAULT_OPTIONS, TUI_TABLE_OPTIONS, TUI_TABLE_PROVIDER, TUI_TABLE_PROVIDERS, TuiCellDirective, TuiDirectionOrderDirective, TuiHeadDirective, TuiResizedDirective, TuiRowDirective, TuiSortByDirective, TuiSortableDirective, TuiTableDirective, TuiTableModule, TuiTableSortPipe, TuiTbodyComponent, TuiTdComponent, TuiThComponent, TuiThGroupComponent, TuiTheadDirective, TuiTrComponent, tuiTableOptionsProvider };
